module.exports = __webpack_public_path__ + "static/media/image2.647ac8e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/image2.png
// module id = 401
// module chunks = 0